module.exports = __webpack_public_path__ + "static/media/banner_420x230_6.8f4aa0a8.jpg";